import { ActionTree } from 'vuex';
import { SearchState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { ClearFacetsFiltersAction } from './actions/clear-facets-filters.action';
import { CloseFacetsPanelsAction } from './actions/close-facets-panels.action';
import { LoadPreselectedFiltersAction } from './actions/load-preselected-filters.action';
import { RedirectionAction } from './actions/redirection.action';
import { ResetFacetsCollapseAction } from './actions/reset-facets-collapse.action';
import { DispatchSearchAction } from './actions/search.action';
import { SetFacetsGroupsAction } from './actions/set-facets-groups.action';
import { ToggleFilterAction } from './actions/toggle-filter.action';

export const SEARCH_ACTIONS: ActionTree<SearchState, RootStoreState> = {
  ...new DispatchSearchAction().actions,
  ...new ToggleFilterAction().actions,
  ...new RedirectionAction().actions,
  ...new ClearFacetsFiltersAction().actions,
  ...new SetFacetsGroupsAction().actions,
  ...new CloseFacetsPanelsAction().actions,
  ...new ResetFacetsCollapseAction().actions,
  ...new LoadPreselectedFiltersAction().actions
};
